export default __webpack_public_path__ + "static/media/talha.b3c7a039.png";